
export default [
  {
    path: '/futures/mail',
    name: 'mail',
    component: () => import('@/pages/mail/index'),
    meta: {
        i18n: {
            zh_CN: () => require("@/i18n/lang/mail/zh.js"),
            en_US: () => require("@/i18n/lang/mail/en.js"),
            ko_KR: () => require("@/i18n/lang/mail/kr.js"),
            zh_TW: () => require("@/i18n/lang/mail/tw.js"),
            ja_JP: () => require("@/i18n/lang/mail/ja_JP.js"),
            vi_VN: () => require("@/i18n/lang/mail/vi.js"),
            id_ID: () => require("@/i18n/lang/mail/ba.js"),
            tr_TR: () => require("@/i18n/lang/mail/tr.js"),
            ru_Ru: () => require("@/i18n/lang/mail/ru.js"),
            fr_FR: () => require("@/i18n/lang/mail/fr.js")
        }
    }
  },
  {
    path: '/futures/mail/:id',
    name: 'mail',
    component: () => import('@/pages/mail/detail'),
    meta: {
        i18n: {
            zh_CN: () => require("@/i18n/lang/mail/zh.js"),
            en_US: () => require("@/i18n/lang/mail/en.js"),
            ko_KR: () => require("@/i18n/lang/mail/kr.js"),
            zh_TW: () => require("@/i18n/lang/mail/tw.js"),
            ja_JP: () => require("@/i18n/lang/mail/ja_JP.js"),
            vi_VN: () => require("@/i18n/lang/mail/vi.js"),
            id_ID: () => require("@/i18n/lang/mail/ba.js"),
            tr_TR: () => require("@/i18n/lang/mail/tr.js"),
            ru_Ru: () => require("@/i18n/lang/mail/ru.js"),
            fr_FR: () => require("@/i18n/lang/mail/fr.js")
        }
    }
  },
]


// WEBPACK FOOTER //
// ./src/router/mail.js